import { X } from "lucide-react";

// Post-submit nudge shown after a guest casts a vote. Offers to convert the
// anonymous guest into a real Google account while preserving the vote they
// just cast on this poll (see plan Task 7 / C5). `onConvert` triggers the
// link/migration flow; the stash is written BEFORE the popup opens (caller).
export default function MakeAccountNudge({ onConvert, onDismiss }) {
  return (
    <div
      role="status"
      className="relative mt-6 flex flex-col gap-3 rounded-2xl border border-brand-primary/30 bg-brand-primary/5 p-5 dark:border-brand-primary/40 dark:bg-brand-primary/10"
    >
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="absolute right-3 top-3 rounded-full p-1.5 text-slate-400 transition-colors hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary dark:hover:text-slate-200"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      ) : null}
      <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100">
        Make an account for free
      </h3>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Sign in with Google to keep your vote on this poll, manage your sessions, and get notified
        when times are picked.
      </p>
      <div>
        <button
          type="button"
          onClick={onConvert}
          className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-brand-primary px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
        >
          <GoogleGlyph aria-hidden="true" />
          Continue with Google
        </button>
      </div>
    </div>
  );
}

function GoogleGlyph(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" {...props}>
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.61z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.71H.96v2.33A9 9 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.71A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.17.29-1.71V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.82.96 4.04l3.01-2.33z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.96l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
